import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import PerflexionApp from "./PerflexionApp";
import "./perflexion.css";

const Perflexion = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Perflexion" pageTitle="Apps" />
          <div className="perflexion-app">
            <PerflexionApp />
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Perflexion;
